module.exports = __webpack_public_path__ + "img/transport_paavirkning_vannuttak_hymo.d292a75d.jpg";